var formatDatasMixin = {
  methods: {
    formatDatas(items, fields, excludeDates = false) {
      let formattedItems = []
      items.forEach(item => {
        formattedItems.push(this.formatData(item, fields, excludeDates))
      })
      return formattedItems
    },
    formatData(item, fields, excludeDates = false) {
      let formattedItem = {
        ...item
      };
      fields.forEach(field => {
        if (field.formatter && !field.isHtml && (excludeDates !== true || field.type != 'date')) {
          formattedItem[field.name] = field.formatter(
            this,
            formattedItem[field.name],
            item
          );
        }
      });
      return formattedItem;
    }
  }
}

export default formatDatasMixin;



// WEBPACK FOOTER //
// ./src/mixins/formatDatas.js